import { styled as muiStyled } from "@mui/material/styles";

const drawerWidth = 260;

const Main = muiStyled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "sx",
})(({ theme, open, paddingUnset }) => ({
  position: "relative",
  flexGrow: 1,
  padding: !paddingUnset && theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
  marginTop: "75px",
  height: "calc(100vh - 75px)",
  overflow: "hidden",
  overflowY: "scroll",
  scrollBehavior: "smooth",
  width: "100%",
  background: "#f3f2f1",
  // background: "#fff",

  [theme.breakpoints.down("md")]: {
    marginTop: "65px",
  },
  [theme.breakpoints.down("sm")]: {
    // padding: "16px",
    marginTop: "65px",
    height: "calc(100vh - 64px)",
  },
}));

// marginTop: "75px",
//   height: "calc(100vh - 75px)",
//   overflow: "hidden",
//   overflowY: "scroll",
//   scrollBehavior: "smooth",
//   width: "100%",
//   background: "#fff",
//   [theme.breakpoints.down(768)]: {
//     padding: 16,
//   },
// }));

export default Main;
